import { Component, OnInit } from '@angular/core';
import { RentalsService } from '../../../../../services/rentals.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-rental-custom-widget-questions',
  templateUrl: './rental-custom-widget-questions.component.html',
  styleUrls: ['./rental-custom-widget-questions.component.scss'],
})
export class RentalCustomWidgetQuestionsComponent implements OnInit {
  public partner: any = {};
  public loading: boolean = false;
  public customQuestions: any = [];
  public categories: any = [];

  public customQuestionsTemplate = [
    {
      icon: 'fa-keyboard-o',
      name: this.translate.instant(
        'bikeshop.rentals.custom_questions.text_input',
      ),
      controlType: 'TEXTINPUT',
    },
    {
      icon: 'fa-file-code-o',
      name: this.translate.instant(
        'bikeshop.rentals.custom_questions.text_area',
      ),
      controlType: 'TEXTAREA',
    },
    {
      icon: 'fa-check-square-o',
      name: this.translate.instant(
        'bikeshop.rentals.custom_questions.checkbox',
      ),
      controlType: 'CHECKBOX',
    },
  ];

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.getProductCategories();
    this.getCustomQuestions();
  }

  getCustomQuestions() {
    this.loading = true;
    this.rentalsService.getRentalCustomQuestions(this.partner.ID).subscribe(
      (questions) => {
        this.customQuestions = questions;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      },
    );
  }

  getProductCategories() {
    this.rentalsService
      .getRentalProductCategories(this.partner.ID)
      .subscribe((res) => {
        this.categories = res;
        console.log(this.categories);
      });
  }

  dropTemplate(event) {
    console.log(event);
    this.customQuestions.push({
      question: '',
      controlType: event.item.data.controlType,
      hint: '',
      mandatory: false,
    });
  }

  getTypeLabel(controlType) {
    return this.customQuestionsTemplate
      .filter((x) => {
        return x.controlType === controlType;
      })
      .pop().name;
  }

  isValid(question) {
    return question.question && question.question.length > 0;
  }

  saveQuestion(question, index) {
    question.saving = true;
    var data = { ...question, defaultPartnerID: this.partner.ID };
    this.rentalsService.updateRentalCustomQuestion(data).subscribe(
      (res) => {
        this.customQuestions[index] = res;
        question.saving = false;
        this.messageService.add({
          life: 2000,
          detail: this.translate.instant(
            'bikeshop.rentals.custom_questions.question_saved',
          ),
        });
      },
      (err) => {
        question.saving = false;
      },
    );
  }

  deleteQuestion(question, index) {
    this.customQuestions.splice(index, 1);
    if (question.id) {
      //this.saving = true;
      this.rentalsService
        .deleteRentalCustomQuestion(this.partner.ID, question.id)
        .subscribe(
          (res) => {
            //this.saving = false;
          },
          (err) => {
            //this.saving = false;
          },
        );
    }
  }

  linkCategory(question, categoryID) {
    if (
      question.linkedCategories === null ||
      question.linkedCategories === undefined
    ) {
      question.linkedCategories = [];
    }

    if (!this.isCategoryLinked(question, categoryID)) {
      question.linkedCategories.push(categoryID);
    } else {
      question.linkedCategories.splice(
        question.linkedCategories.indexOf(categoryID),
        1,
      );
    }
  }

  isCategoryLinked(customQuestion, categoryID) {
    return (
      customQuestion.linkedCategories &&
      customQuestion.linkedCategories.indexOf(categoryID) > -1
    );
  }
}
